/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Meta_Team_SubtitleInputs */



/**
* | output |
* | --- |
* | "For compliance teams at scale" |
*
* @param {Plan_Meta_Team_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_meta_team_subtitle = /** @type {((inputs?: Plan_Meta_Team_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Meta_Team_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für Compliance-Teams im großen Maßstab")
	return /** @type {LocalizedString} */ ("For compliance teams at scale")
});